
import vsDarker from './vs-darker';

type themeList = {
	[themeName: string]: any;
	//this is the correct type. Not sure why it doesn't fit
	// editor.IStandaloneThemeData;
};

export function getThemes(): themeList {
	return {
		"bit-vs-dark": vsDarker
	}
};